<script lang="ts">
  import type { SimpleVerificationInputList } from '$shared/components/types';

  interface Props {
    list?: SimpleVerificationInputList[];
  }

  let { list = [] }: Props = $props();
</script>

<div class="simple-verification-input-comp">
  {#each list || [] as param}
    <div class="param-li" class:required={param.required}>
      <div data-cy={`${param.label}-k`} class="key">{param.label}</div>
    </div>
  {/each}
</div>

<style>
  .param-li {
    display: flex;
    align-items: flex-start;
    margin-bottom: 6px;
  }
  .param-li::before {
    content: '•';
    margin-right: 6px;
  }
  .param-li .key {
    width: 100px;
    line-height: 20px;
    position: relative;
    flex-shrink: 0;
    color: #080707;
  }
  .param-li.required .key::after {
    content: '*';
    margin-left: 2px;
  }
</style>
